// Mirrors ca-backend/services/dprCmaDirectEngine.js's OS_LINES/BS_LINES —
// duplicated here since the frontend bundle can't import the backend
// service directly. Keep both lists in sync if either changes.
export const OS_LINES = [
  { key: 'grossSales', label: 'Gross Sales' },
  { key: 'lessDeductions', label: 'Less: Excise Duty / Deductions' },
  { key: 'rawMaterials', label: 'Raw Materials Consumed' },
  { key: 'powerFuel', label: 'Power & Fuel' },
  { key: 'directLabour', label: 'Direct Labour' },
  { key: 'otherDirectExpenses', label: 'Other Direct Expenses' },
  { key: 'depreciation', label: 'Depreciation' },
  { key: 'sgaExpenses', label: 'Selling, General & Admin Expenses' },
  { key: 'interestOnTL', label: 'Interest — Term Loan' },
  { key: 'interestOnWC', label: 'Interest — Working Capital' },
  { key: 'otherNonOperatingIncome', label: 'Other Non-Operating Income' },
  { key: 'otherNonOperatingExpense', label: 'Other Non-Operating Expenses' },
  { key: 'taxProvision', label: 'Provision for Tax' },
  { key: 'dividendPaid', label: 'Dividend Paid' },
];

export const BS_LINES = [
  { key: 'capital', label: 'Ordinary Share Capital / Proprietor Capital' },
  { key: 'reserves', label: 'Reserves & Surplus' },
  { key: 'termLoanOutstanding', label: 'Term Loan Outstanding' },
  { key: 'wcBorrowing', label: 'Working Capital Borrowing (Cash Credit/OD)' },
  { key: 'sundryCreditors', label: 'Sundry Creditors (Trade)' },
  { key: 'otherCurrentLiabilities', label: 'Other Current Liabilities & Provisions' },
  { key: 'freeholdLand', label: 'Freehold Land' },
  { key: 'netBlock', label: 'Net Fixed Assets (Gross Block − Depreciation)' },
  { key: 'cashAndBank', label: 'Cash & Bank Balances' },
  { key: 'receivables', label: 'Sundry Debtors / Receivables' },
  { key: 'inventory', label: 'Inventory (RM + WIP + Finished Goods)' },
  { key: 'otherCurrentAssets', label: 'Other Current Assets' },
];
